import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { lazy, Suspense } from "react";
import { ToastContainer } from 'react-toastify';

const Loaders = lazy(() => import("./Components/Loaders"));
const LandingPage = lazy(() => import("./Components/LandingPage"));
const Login = lazy(() => import("./Components/Login"));
const ProtectedRoute = lazy(() => import("./Components/ProtectedLayout"));
const Dashboard = lazy(() => import("./Container/Dashboard/Dashboard"));
const Appointments = lazy(() => import("./Container/Appointments/Appointments"));
const Patients = lazy(() => import("./Container/Patients/Patients"));
const Treatments = lazy(() => import("./Container/Treatments/Treatments"));
const Billing = lazy(() => import("./Container/Billing/Billing"));
const MedicineManager = lazy(() => import("./Container/MedicineManager/MedicineManager"));
const Prescriptions = lazy(() => import("./Container/Prescriptions/Prescriptions"));
const Doctor = lazy(() => import("./Container/Doctor/Doctor"));
const Clinic = lazy(() => import("./Container/clinic/Clinic"));
const Receptionist = lazy(() => import("./Container/Receptionist/Receptionist"));
const CreatePrescription = lazy(() => import("./Container/Prescriptions/CreatePrescription"));
const Prescriptiondetails = lazy(() => import("./Container/Prescriptions/Prescriptiondetails"));
const DashboardDetails = lazy(() => import("./Container/Dashboard/DashboardDetails"));
const ConsultationRequests = lazy(() => import("./Container/ConsultationRequests/ConsultationRequests"));

function App() {
  return (
    <>
      <Router>
        <Suspense fallback={<Loaders />}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<Dashboard />} path="/dashboard" />
              <Route element={<DashboardDetails />} path="/dashboardDetails" />
              <Route element={<Appointments />} path="/appointments" />
              <Route element={<Patients />} path="/patients" />
              <Route element={<Treatments />} path="/treatments" />
              <Route element={<Billing />} path="/billing" />
              <Route element={<MedicineManager />} path="/medicineManager" />
              <Route element={<Prescriptions />} path="/prescriptions" />
              <Route element={<Doctor />} path="/doctors" />
              <Route element={<Clinic />} path="/clinics" />
              <Route element={<Receptionist />} path="/receptionists" />
              <Route element={<CreatePrescription />} path="/createPrescription" />
              <Route element={<Prescriptiondetails />} path="/prescriptionDetails" />
              <Route element={<ConsultationRequests />} path="/consultationRequests" />
            </Route>
          </Routes>
        </Suspense>
      </Router>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        pauseOnHover
        theme="colored"
      />
    </>
  );
}

export default App;
